import React from 'react';

const Footer = () => {
    return (
        <footer className="p-4 text-black dark:text-white">
            © {new Date().getFullYear()}, Built with
            {` `}
            <a href="https://www.gatsbyjs.com">Gatsby</a>
        </footer>
    )
}

export default Footer